import { createContext, useContext } from 'react';
import { FilterSelectionStateGroup } from '../types';

export const GroupContext = createContext<FilterSelectionStateGroup | null>(null);

export function useGroupContext() {
  return useContext(GroupContext);
}
